module.exports = __webpack_public_path__ + "img/master-vis.7f6009c9.png";